import { CalendarGridItemVariant } from '../../../../../constants/calendarGrid'
import { VIEWING_TERMINAL_STATUSES } from '../../../../../constants/rentalPortal'
import { getListingUnitLabel } from '../../../../RentalPortalListing'
import {
  getIsViewingApplicantPreviewable,
  getIsViewingOpenSlot,
  getIsViewingSlotBookable,
} from '../../../../RentalPortalViewing'

function getViewingCalendarGridVariant(viewing) {
  if (getIsViewingOpenSlot(viewing)) {
    return CalendarGridItemVariant.free
  }

  return VIEWING_TERMINAL_STATUSES.includes(viewing.status)
    ? CalendarGridItemVariant.muted
    : CalendarGridItemVariant.brand
}

function getViewingCalendarGridSlotTooltipKey(isBookable) {
  return isBookable
    ? 'RentalPortal.ViewingFormBookSubmitKey'
    : 'RentalPortal.ViewingCalendarFreeSlotTooltipKey'
}

export function toViewingCalendarGridItem({ t, timezone, viewing }) {
  const isOpenSlot = getIsViewingOpenSlot(viewing)

  const isBookable = getIsViewingSlotBookable({ timezone, viewing })

  return {
    date: viewing.start.slice(0, 10),
    end: viewing.end,
    id: viewing.id,
    isAllDay: false,
    isDisabled: isOpenSlot && !isBookable,
    isOpenedDirectly: true,
    isSecondaryLabelClickable: getIsViewingApplicantPreviewable(viewing),
    isSecondaryLabelPinned: true,
    popover: { kindLabel: t('RentalPortal.ViewingCalendarKindKey') },
    secondaryLabel:
      viewing.applicant_label ?? getListingUnitLabel({ listing: viewing, t }),
    source: viewing,
    start: viewing.start,
    tooltip: isOpenSlot
      ? t(getViewingCalendarGridSlotTooltipKey(isBookable))
      : null,
    variant: getViewingCalendarGridVariant(viewing),
  }
}
